/* src/components/pdf-page/pdf-page.component.scss */
app-pdf-page {
  display: block;
  position: relative;
}
/*# sourceMappingURL=pdf-page.component-OM5O3NF3.css.map */
